/**
 * The usage of the IMask library for masking input fields.
 * Can be set up for different mask types (cvleIMask.targets).
 * See the origin: https://imask.js.org/
 */
document.addEventListener( 'DOMContentLoaded', function() {
  let maskOptions = window.cvleFormMaskOptions?.[ 'tel-dynamic' ];
  if ( maskOptions ) {
    maskOptions = maskOptions.filter( ( elem ) => elem.mask );
    maskOptions = maskOptions.map( ( elem ) => ( {
      ...elem,
      lazy: elem.lazy === '1',
    } ) );

    // Fallback mask
    maskOptions.push( {
      country: 'Unknown',
      mask: '000000000000000',
      startsWith: '',
      lazy: true,
    } );
  }
  const cvleIMask = {
    targets: {
      phone: {
        selector: '[type="tel"]',
        maskOptions: {
          mask: maskOptions || window.cvleFormMaskOptions?.[ 'tel-format' ] || '(000)000-0000',
          dispatch: ( appended, dynamicMasked ) => {
            const number = ( dynamicMasked.value + appended ).replace( /\D/g, '' );

            return dynamicMasked.compiledMasks.find( ( m ) => number.indexOf( m.startsWith ) === 0 );
          },
        },
      },
      currency: {
        selector: '.wpcf7-currency-mask',
        maskOptions: {
          mask: '$num',
          blocks: {
            num: {
              mask: Number,
              thousandsSeparator: ',',
              radix: '.',
            },
          },
        },
      },
    },
    /** what elements will trigger script load and on what events */
    triggers: {
      selectorContainers: 'form',
      selectorElements: 'a, button, input, textarea, select',
      ignoreFieldClass: 'js-form-mask-ignore',
      events: [ 'focus' ],
    },
    script: {
      src: 'https://www.unpkg.com/imask@6.0.1/dist/imask.min.js',
      loading: false,
    },
    init() {
      this.setTriggerContainers();
      this.getTargetItems();
      this.setTriggerItems();

      this.listenersBind();
    },
    setTriggerContainers() {
      this.triggers.containers = document.querySelectorAll( this.triggers.selectorContainers );
    },
    /** find all items to be masked later */
    getTargetItems() {
      this.triggers.containers.forEach( ( container ) => {
        container.targetsCount = 0;
        for ( const targetOptions of Object.values( this.targets ) ) {
          const targetItems = container.querySelectorAll( targetOptions.selector );
          if ( targetItems.length > 0 ) {
            targetOptions.items = targetOptions.items ?? [];
            targetItems.forEach( ( item ) => {
              if (
                item.classList.contains( this.triggers.ignoreFieldClass ) ||
                item.closest( '.' + this.triggers.ignoreFieldClass )
              ) {
                return;
              }
              targetOptions.items.push( item );
            } );
            container.targetsCount += targetItems.length;
          }
        }
      } );
    },
    /** find all script loading triggers in each container with target elements */
    setTriggerItems() {
      this.triggers.containers.forEach( ( container ) => {
        if ( container.targetsCount === 0 ) {
          return;
        }
        const triggerItems = container.querySelectorAll( this.triggers.selectorElements );
        if ( triggerItems.length === 0 ) {
          return;
        }
        this.triggers.elements = this.triggers.elements ?? [];
        triggerItems.forEach( ( item ) => {
          this.triggers.elements.push( item );
        } );
      } );
    },
    /** add script loading event listeners */
    listenersBind() {
      this.triggers.elements = this.triggers.elements ?? [];
      this.triggers.elements.forEach( ( element ) => {
        this.triggers.events.forEach( ( event ) => {
          element.addEventListener( event, this.scriptLoader, false );
        } );
      } );
    },
    /** remove script loading event listeners */
    listenersUnbind() {
      this.triggers.elements.forEach( ( element ) => {
        this.triggers.events.forEach( ( event ) => {
          element.removeEventListener( event, this.scriptLoader, false );
        } );
      } );
    },
    scriptLoader() {
      const _t = cvleIMask;
      /** prevent subsequent events */
      if ( _t.script.loading ) {
        return;
      }
      _t.script.loading = true;

      const _s = document.createElement( 'script' );
      _s.src = _t.script.src;
      document.body.appendChild( _s );
      _s.onload = _t.onScriptLoad();
    },
    onScriptLoad() {
      this.listenersUnbind();
      this.onIMaskReady();
    },
    /** IMask is undefined right after the script loads. So we'll wait its definition */
    async onIMaskReady() {
      while ( typeof window.IMask === 'undefined' ) {
        await new Promise( ( resolve ) => setTimeout( resolve, 100 ) );
      }
      this.maskTargets();
    },
    /** set masks for all items found earlier */
    maskTargets() {
      for ( const targetOptions of Object.values( this.targets ) ) {
        if ( typeof targetOptions.items === 'undefined' ) {
          continue;
        }
        targetOptions.items.forEach( ( item ) => {
          window.IMask( item, targetOptions.maskOptions ); // eslint-disable-line no-undef
        } );
      }
    },
  };
  window.cvleIMask = cvleIMask;
  cvleIMask.init();
} );
